import { ThemeProvider } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useMemo } from 'react';
import { FC, PropsWithChildren } from 'react';
import {
  getCurrentMuiDatePickersLocaleText,
  getCurrentMuiDatePickersLocale,
  useLocale,
} from './date-helper';

export const MuiProvider: FC<PropsWithChildren> = (props) => {
  const locale = useLocale();
  const theme = useMemo(
    () => createTheme(undefined, getCurrentMuiDatePickersLocale()),
    [],
  );
  const localeText = useMemo(() => {
    const result =
      getCurrentMuiDatePickersLocaleText().components.MuiLocalizationProvider
        .defaultProps.localeText;
    const oldResult = { ...result };
    result.fieldDayPlaceholder = (p) =>
      oldResult.fieldDayPlaceholder!(p).toLowerCase();
    result.fieldYearPlaceholder = (p) =>
      oldResult.fieldYearPlaceholder!(p).toLowerCase();
    result.fieldMonthPlaceholder = (p) =>
      oldResult.fieldMonthPlaceholder!(p).toLowerCase();
    result.fieldHoursPlaceholder = (p) =>
      oldResult.fieldHoursPlaceholder!(p).toLowerCase();
    result.fieldMinutesPlaceholder = (p) =>
      oldResult.fieldMinutesPlaceholder!(p).toLowerCase();
    result.fieldSecondsPlaceholder = (p) =>
      oldResult.fieldSecondsPlaceholder!(p).toLowerCase();
    return result;
  }, [locale]);
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={locale}
        localeText={localeText}
      >
        {props.children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
